<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">

        <div class="col-12  mt-2 py-0">
          <h4 class="m-0 p-0 text-secondary d-inline">Laporan penjualan unit</h4>

          <b-button v-b-modal.modal-pdf class="btn btn-warning mx-3 mb-1" title="Print PDF"><b-icon icon="printer"></b-icon></b-button>
          <b-button class="btn btn-success mx-1 mb-1" title="Print Excel" v-on:click="getUnitReportsExcel()"><b-icon icon="printer"></b-icon></b-button>

          <b-modal no-close-on-esc  content-class="m-0"  id="modal-pdf" title="Cetak laporan penjualan unit" scrollable no-close-on-backdrop  size="lg">
            <b-container>
              <b-row>
                <div class="col-12 col-md-6 col-lg-4 mt-2" style="height:80px">
                  <div style="position:fixed;z-index:1100">
                    <label class="d-block">Tanggal mulai <span style="color:red;">*</span></label>
                    <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-start-print" class="mb-2" v-model="printPDF.start">{{printPDF.start}}</b-form-datepicker>
                  </div>    
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <div style="position:fixed;z-index:1000">
                    <label class="d-block">Tanggal selesai <span style="color:red;">*</span></label>
                    <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-end-print" class="mb-2"  v-model="printPDF.end">{{printPDF.end}}</b-form-datepicker>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 my-2 d-flex align-items-end">
                  <button class="btn btn-primary" type="button" v-on:click="savePDF"><span v-if="savingPDF" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Submit</button>
                </div>
              </b-row>
            </b-container>
            <template #modal-footer>
              <div class="w-100 text-right m-0 p-0">
                <hr>
                <b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-pdf'):''">Tutup</b-button>
              </div>
            </template>
          </b-modal>

          <b-modal no-close-on-esc  content-class="m-0"  id="modal-excel" title="Cetak laporan penjualan unit" scrollable no-close-on-backdrop  size="lg">
            <b-container>
              <b-row>
                <div class="col-12 col-md-6 col-lg-4 mt-2" style="height:80px">
                  <div style="position:fixed;z-index:1100">
                    <label class="d-block">Tanggal mulai <span style="color:red;">*</span></label>
                    <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-start-print" class="mb-2" v-model="printExcel.start">{{printExcel.start}}</b-form-datepicker>
                  </div>    
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                  <div style="position:fixed;z-index:1000">
                    <label class="d-block">Tanggal selesai <span style="color:red;">*</span></label>
                    <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-end-print" class="mb-2"  v-model="printExcel.end">{{printExcel.end}}</b-form-datepicker>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4 my-2 d-flex align-items-end">
                  <button class="btn btn-primary" type="button" v-on:click="getUnitReportsExcel"><span v-if="savingExcel" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Submit</button>
                </div>
              </b-row>
            </b-container>
            <template #modal-footer>
              <div class="w-100 text-right m-0 p-0">
                <hr>
                <b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-excel'):''">Tutup</b-button>
              </div>
            </template>
          </b-modal>

          <br>
          <br>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4 mt-2">
              <label class="d-block">Tanggal mulai <span style="color:red;">*</span></label>
              <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-start" class="mb-2" v-model="searchListing.start">{{searchListing.start}}</b-form-datepicker>
            </div>
            <div class="col-12 col-md-6 col-lg-4 mt-2">
              <label class="d-block">Tanggal selesai <span style="color:red;">*</span></label>
              <b-form-datepicker today-button reset-button close-button locale="id" :date-format-options="{day: 'numeric', month: 'long', year: 'numeric'}" id="datepicker-end" class="mb-2"  v-model="searchListing.end">{{searchListing.end}}</b-form-datepicker>
            </div>
            <div class="col-12 col-md-6 col-lg-4 my-2 d-flex align-items-end">
              <button class="btn btn-primary" type="button" v-on:click="saveListing"><span v-if="savingListing" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Submit</button>
            </div>
            <!-- <div class="col-12 mt-3">
              <div class="w-100 align-items-center justify-content-start" v-if="savedListing">
                <div class="alert alert-success" role="alert">
                    Berhasil Menyimpan Data Aplikasi Baru.
                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <div class="w-100 align-items-center justify-content-start" v-if="errorSearchListing">
                <div class="alert alert-danger" role="alert">
                  <div class="my-0">
                    <p class="d-block mt-1">{{createErrorMessage}}</p>
                  </div>
                  <div v-for="err in errorList" v-bind:key="err" class="my-0">
                    <p v-for="note in err" v-bind:key="note" class="d-block mt-1 w-100">{{note}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex align-items-center justify-content-start" v-if="savingListing">
                <div class="spinner-border" role="status" aria-hidden="true"></div>
                <strong class=" ml-2">Mencari data, tunggu sebentar.</strong>
              </div>
            </div> -->
            
          </div>
        </div>

        <!-- <transition name="fade">
          <div class="col-12  my-2 py-0" v-if="formApplicationActive">
            <div class="row p-3 mx-2 bg-white shadow">
                <div class="col-12 mb-3">
                    <h4 class="my-0 py-0">Form Data Aplikasi Baru</h4>
                    <hr>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Tanggal Mulai <span style="color:red;">*</span></label>
                    <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-start-date" v-model="start" class="mb-2">{{newHardwareSetup.start}}</b-form-datepicker>
                </div>
                <div class="col-12 col-md-6 col-lg-4 mt-2">
                    <label class="d-block">Tanggal Selesai <span style="color:red;">*</span></label>
                    <b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-end-date" v-model="newHardwareSetup.date_active" class="mb-2">{{newHardwareSetup.end}}</b-form-datepicker>
                </div>
                <div class="col-12 mt-3">
                    <div class="w-100 align-items-center justify-content-start" v-if="savedListing">
                        <div class="alert alert-success" role="alert">
                            Berhasil Menyimpan Data Aplikasi Baru.
                        </div>
                    </div>
                </div>
                
                <div class="col-12 mt-3">
                    <div class="w-100 align-items-center justify-content-start" v-if="errorSearchListing">
                        <div class="alert alert-danger" role="alert">
                            <div class="my-0">
                                <p  class="d-block mt-1">{{createErrorMessage}}</p>
                            </div>
                            <div v-for="err in errorList" v-bind:key="err" class="my-0">
                                <p  v-for="note in err" v-bind:key="note" class="d-block mt-1 w-100">{{note}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3">
                    <div class="d-flex align-items-center justify-content-start" v-if="savingListing">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                    </div>
                    <button class="btn btn-primary float-right" type="button" v-on:click="saveListing">Submit</button>
                </div>
            </div>
        </div>
        </transition> -->

        <!-- <div class="col-12 mt-2 py-0">
          <b-button class="btn btn-warning mr-2 mb-1" title="print"><b-icon icon="printer"></b-icon></b-button>
        </div> -->

          <div class="col-12 my-2 py-0"> <!--LAPORAN PENJUALAN UNIT-->
            <chart-card
              v-if="itemHistoryReady"
              :chart-data="itemHistories.data"
              :chart-options="itemHistories.options"
              :chart-responsive-options="itemHistories.responsiveOptions"
              chart-type="Bar">
              <template slot="header">
                <h4 class="card-title">Laporan penjualan unit</h4>
                <div class="col-6 col-md-3 col-lg-3 my-2 text-left">
                  <select class="custom-select custom-select-sm" @change="refetchItem" v-model="selectedItemYear">
                    <option v-for="(item,idx) in InvoiceItemYears" v-bind:key="'iteminvoiceitemyear'+idx">{{item.year}}</option>
                  </select>
                </div>
              </template>
            </chart-card>
          </div>
          <!-- <div class="col-6 my-2 py-0"> 
          </div> -->

        <div class="col-12 my-2 py-0">
          <div class="row">
            <div class="col-3">
              <select class="custom-select custom-select-sm" v-model="rowLimit" v-on:change="getUnitReports()">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
          <datatable 
          :currentIdx="currentPage"
          :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
          use-filter
          no-toolbar :datas="unitreports" :structure="TableStructure" :init="loadData" use-seeker seeker-url="/api/report/json/unit-sales" @searching="(val)=>!val.status?getUnitReports():unitreports=val.data">
              <template #customcell={obj,index}>
                  <td v-if="isMobile" class="py-3">
                      <ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
                          <li class="mt-2">
                              <div class="text-left mx-3 pt-0">
                                <small class="my-0 py-0">Tanggal invoice:</small>
                                <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.invoice_date | timeformat }}</b>
                              </div>
                              <hr class="my-1">
                              <div class="text-left mx-3 pt-0">
                                <small class="my-0 py-0">Nomor invoice:</small>
                                <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.invoice_no }}</b>
                              </div>
                              <div class="text-left mx-3 pt-0">
                                <small class="my-0 py-0">ID transmitter:</small>
                                <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.invoice_metadata[0].order_metadata.hardware_setup == null? '': obj.invoice_metadata[0].order_metadata.hardware_setup.id_transmitter }}</b>
                              </div>
                              <div class="text-left mx-3 pt-0">
                                <small class="my-0 py-0">Total (IDR):</small>
                                <br><b class="py-0 mx-0" style="font-size:10pt">Rp {{ obj.total | numeral('0,0') }}</b>
                              </div>
                              <!-- <div class="text-left mx-3 pt-0">
                                <small class="my-0 py-0">Nama kapal:</small>
                                <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.name }}</b>
                              </div>
                              <div class="text-left mx-3 pt-0">
                                <small class="my-0 py-0">Pelanggan:</small>
                                <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.client.legal_name }}</b>
                              </div> -->
                          </li>
                          <!-- <li class="mt-2">
                              <div class="text-left mx-3 pt-0">
                                  <b-button v-b-modal.modal-edit-application class="btn btn-info mr-2" v-on:click="selectedApplication=index;dataEdit=Object.assign({},obj)"><b-icon icon="pencil-square"></b-icon></b-button>
                                  <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger"><b-icon icon="trash"></b-icon></b-button>
                              </div>
                          </li> -->
                      </ul>
                  </td>
                  <td v-if="!isMobile" >{{ index+ 1 }}</td>
                  <td v-if="!isMobile" >{{ obj.invoice_date | timeformat }}</td>
                  <td v-if="!isMobile" >{{ obj.invoice_no }}</td>
                  <td v-if="!isMobile" >{{ obj.invoice_metadata[0].order_metadata.hardware_setup == null? '': obj.invoice_metadata[0].order_metadata.hardware_setup.id_transmitter }}</td>
                  <td v-if="!isMobile" >Rp {{ obj.total | numeral('0,0') }}</td>
                  <!-- <td v-if="!isMobile" >{{ obj.invoice_metadata[0].order_metadata.hardware_setup.vessel.name }}</td>
                  <td v-if="!isMobile" >{{ obj.client.legal_name }}</td> -->
                  <!-- <td v-if="!isMobile" >
                      <b-button v-b-modal.modal-edit-application class="btn btn-info mr-2" v-on:click="selectedApplication=index;dataEdit=Object.assign({},obj)"><b-icon icon="pencil-square"></b-icon></b-button>
                      <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger"><b-icon icon="trash"></b-icon></b-button>
                  </td> -->
              </template>
          </datatable>
        </div>

        <b-modal no-close-on-esc  content-class="m-0"  id="modal-edit-application" title="Edit Nama Aplikasi" scrollable no-close-on-backdrop size="lg" @hide="editModalClose">
          <b-container fluid v-if="!loadData&&unitreports.length>0">
              <b-row class="mt-3 pt-1" v-if="unitreports[selectedApplication]!=undefined">
                  <b-col cols="12" class="my-1">
                  </b-col>
                  <b-col cols="12" md="6" lg="4">
                      <label class="d-block">Nama Aplikasi</label>
                      <input type="text"  class="form-control w-100 rounded" v-model="unitreports[selectedApplication].application_name" />
                  </b-col>
                  
                  <b-col cols="12" class="my-3 text-right"  v-if="updateApplicationState">
                  <div class="d-flex align-items-center justify-content-start">
                          <div class="spinner-border" role="status" aria-hidden="true"></div>
                          <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                      </div>
                  </b-col>
                  <div class="col-12 mt-3"  v-if="updateApplicationSaved">
                      <div class="w-100 align-items-center justify-content-start">
                          <div class="alert alert-success" role="alert">
                              Berhasil update data aplikasi.
                          </div>
                      </div>
                  </div>
                  <div class="col-12 mt-3"  v-if="errorApplicationSaved">
                      <div class="w-100 align-items-center justify-content-start">
                          <div class="alert alert-danger" role="alert">
                              Gagal update data aplikasi.
                          </div>
                      </div>
                  </div>
                  <b-col cols="12" class="my-3 text-right">
                      <button class="btn btn-info" v-on:click="updateApplicationData">Simpan</button>
                  </b-col>
              </b-row>
          </b-container>
          <template #modal-footer>
              <div class="w-100 text-right m-0 p-0">
              <hr>
              <b-button class="btn btn-secondary mr-2" @click="(!updateApplicationState&&!updateApplicationState)?$bvModal.hide('modal-edit-application'):''">Tutup</b-button>
              <!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
              </div>
          </template>
        </b-modal>
        <modal-delete url="/api/master/unitreports/" @read="()=>{console.log('modal ready')}" @result="deleteResult" :targetid="deleteId">
        Yakin mau menghapus data dengan detail berikut :<br>
        <ul>
            <li>Nama: {{ itemToDelete.application_name }}</li>
        </ul>
        </modal-delete>


      </div>
    </div>
  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import moment from 'moment';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import ModalDelete from '../../components/ModalDelete.vue';
    import ChartCard from 'src/components/Cards/ChartCard.vue';
    import StatsCard from 'src/components/Cards/StatsCard.vue';
    export default {
        components: {
          // LTable,
          // ChartCard,
          // StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'modal-delete':ModalDelete,
            ChartCard,
            StatsCard
        },
        // component: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
        // },
        data () {
            return {
                currentPage: 1,
                perPage: null,
                rowLimit: 10,
                nextUrl: null,
                prevUrl: null,
                months: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                loadDataInvoiceItemYear:true,
                loadDataInvoiceItem:true,
                InvoiceItemYears:{},
                itemHistoryReady:false,
                isMobile:false, //step 1 edit
                dataEdit:null,
                deleteId:0,
                createErrorMessage:'Gagal Menyimpan Data Aplikasi Baru.',
                errorMessages:[],
                itemToDelete:{},
                unitreports:[],
                unitreportexcels:[],
                searchValue:'',
                loadData:true,
                loadDataExcel:true,
                savingListing:false,
                savingPDF:false,
                savingExcel:false,
                errorSearchListing:false,
                errorList:[],
                errorApplicationSaved:false,
                savedListing:false,
                updateApplicationState:false,
                updateApplicationSaved:false,
                selectedApplication:0,
                selectedTab:0,
                updateApplicationCol:6,
                searchListing:{
                  start:'',
                  end:'',
                },
                printPDF:{
                  start:'',
                  end:'',
                },
                printExcel:{
                  start:'',
                  end:'',
                },
                formApplicationActive:false,
                TableStructure:[
                    //label: nama heading, key: nama object property
                    {label:'No',key:null},
                    {label:'Tanggal invoice',key:null},
                    {label:'Nomor invoice',key:null},
                    {label:'ID transmitter',key:null},
                    {label:'Total (IDR)',key:null}
                    // {label:'Nama kapal',key:null},
                    // {label:'Pelanggan',key:null}
                ],
                itemHistories: {
                  data: {
                    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    series: [[1]]
                  },
                  options: {
                    seriesBarDistance: 10,
                    axisX: {
                      showGrid: false
                    },
                    height: '245px'
                  },
                  responsiveOptions: [
                    ['screen and (max-width: 640px)', {
                      seriesBarDistance: 5,
                      axisX: {
                        labelInterpolationFnc (value) {
                          return value[0]
                        }
                      }
                    }]
                  ]
                },
            }
        },
        created(){
            console.clear()
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            console.log("user page")
            this.getUnitReports();
            // this.getUnitReportsExcel();
            this.isMobile = this.$isMobile
            window.addEventListener('resize', ()=>{
              console.log('screen update')
                this.isMobile = screen.width < 768
            });
            if(!localStorage.getItem('accessToken')){
              this.$router.push('/login')
              }else{
                this.getReportInvoiceItem();
                this.getReportInvoiceItemYear();
              }
            console.log("Kata ary tahun sekarang: "+moment().year())
            this.selectedItemYear = moment().year();
            // var newData = [];
            // for(var x=0;x<100;x++){
            //     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
            // }
            // console.log(newData);
            // this.users = newData;
        },
        methods:{
            changePage(isNext) {
              var url = (isNext ? this.nextUrl : this.prevUrl);
              let params = (new URL(url)).searchParams;
              const myParams = params.get("page");
              this.currentPage = myParams;
              var newUrl = this.$baseUrl + "/api/report/json/unit-sales?limit=" + this.rowLimit + "&page=" + myParams;
              this.getUnitReports(newUrl);
            },
            refetchItem(el){
              console.log('target year: '+el.target.value)
              this.itemHistoryReady = false
              this.getReportInvoiceItem(this.$baseUrl+'/api/report/graph-data/invoice-item?year='+el.target.value)
            },
            getReportInvoiceItem(url=(this.$baseUrl+'/api/report/graph-data/invoice-item')){ //FUNCTIONAL GRAPH LAPORAN PENJUALAN ITEM
              this.loadDataInvoiceItem=true
              axios.get(url,{'headers':{
                  'Authorization':'Bearer '+localStorage.getItem('accessToken')
                }
              }
              ).then((result)=>{
                console.log(result)
                //this.vesselTotal = result.data;

                var seriesOne = []
                var labels = []
                for(var x=0;x<result.data.length;x++){
                  labels.push(this.months[result.data[x].month-1])
                  seriesOne.push(result.data[x].total)
                }
                this.itemHistories.data.labels=labels
                this.$set(this.itemHistories.data.series, 0,seriesOne)
                
                
                //this.itemHistories.data.series[0]=seriesOne

                console.log(this.itemHistories.data.labels)
                console.log(this.itemHistories.data.series)
                this.loadDataInvoiceItem=false
                this.itemHistoryReady=true
                this.$forceUpdate()
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                  localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                console.log(err)
                this.loadDataInvoiceItem=false
              })
            },
            getReportInvoiceItemYear(url=(this.$baseUrl+'/api/report/graph-data/invoice-item-sample')){ //FUNCTIONAL GRAPH LAPORAN PENJUALAN ITEM YEAR
              this.loadDataInvoiceItemYear=true
              axios.get(url,{'headers':{
                  'Authorization':'Bearer '+localStorage.getItem('accessToken')
                }
              }
              ).then((result)=>{
                console.log(result)
                this.InvoiceItemYears = result.data;
                this.loadDataInvoiceItemYear=false
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                  localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                console.log(err)
                this.loadDataInvoiceItemYear=false
              })
            },
            deleteResult(deleted){
                console.log(deleted)
                if(deleted){
                    this.getUnitReports();
                }
            },
            getUnitReports(url=(this.$baseUrl+'/api/report/json/unit-sales?limit=' + this.rowLimit)){
              this.loadData=true
              axios.get(url,{'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                  console.log("get di sini")
                  console.log(result.data.data)
                  this.prevUrl = result.data.prev_page_url;
                  this.nextUrl = result.data.next_page_url;
                  this.currentPage = result.data.current_page;
                  this.perPage = parseInt(result.data.per_page);
                  this.unitreports = result.data.data;
                  this.loadData=false;
              }).catch((err)=>{
                  //check if token fail
                  if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                  this.$router.push('/login')
                  }
                  console.log(err)
                  this.loadData=false
              })
            },
            getUnitReportsExcel(){
              this.loadDataExcel=true
              
              axios.get(this.$baseUrl+'/api/report/excel/unit-sales',{
                  'responseType':'blob',
                  'headers':{
                    'Authorization':'Bearer '+localStorage.getItem('accessToken'),
                      
                  }
              }).then((result)=>{
                  console.log("get di sini")
                  // console.log(result.data.data)
                  // this.unitreportexcels = result.data.data;

                  this.downloadEXCEL(result.data,'unit-sales-report.xlsx')
                  this.loadDataExcel=false
                  
              }).catch((err)=>{
                  //check if token fail
                  if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                  this.$router.push('/login')
                  }
                  console.log(err)
                  this.loadDataExcel=false
                  
              })
            },
            saveListing(){
                this.savingListing=true
                // this.errorSearchListing=false
                console.log(this.searchListing)
                axios.post(this.$baseUrl+'/api/report/json/unit-sales', this.searchListing,
                {
                    'headers':
                    {
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result)
                    this.unitreports = result.data.data;
                    //this.getUnitReports();
                    this.savingListing=false
                    // this.savedListing=true
                    setTimeout(() => {
                        // this.savedListing=false
                        // this.formApplicationActive=false
                    }, 1000);

                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                      localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err.response)
                    this.errorList=[]
                    this.errorList=Object.values(err.response.data.errors)
                    console.log(this.errorList)
                    // this.errorSearchListing=true
                    this.savingListing=false
                })
            },
            downloadPDF(data,filename = "file.pdf"){
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename); //or any other extension
              document.body.appendChild(link);
              link.click();
            },
            downloadEXCEL(data,filename = "file.xlsx"){
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', filename); //or any other extension
              document.body.appendChild(link);
              link.click();
            },
            savePDF(){
                this.savingPDF=true
                // this.errorSearchListing=false
                console.log(this.printPDF)
                axios.post(this.$baseUrl+'/api/report/unit-sales', this.printPDF,
                {
                    'responseType':'blob',
                    'headers':
                    {
                        'Authorization':'Bearer '+localStorage.getItem('accessToken'),
                    }
                }).then((result)=>{
                    console.log(result)
                    this.downloadPDF(result.data,'unit-sales-report.pdf')
                    //this.unitreports = result.data.data;
                    //this.getUnitReports();
                    this.savingPDF=false
                    // this.savedListing=true
                    setTimeout(() => {
                        // this.savedListing=false
                        // this.formApplicationActive=false
                    }, 1000);

                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                      localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err.response)
                    this.errorPDF=[]
                    this.errorPDF=Object.values(err.response.data.errors)
                    console.log(this.errorPDF)
                    // this.errorSearchListing=true
                    this.savingPDF=false
                })
            },
            // downloadExcel(data,filename = "file.xlsx"){
            //   const url = window.URL.createObjectURL(new Blob([data]));
            //   const link = document.createElement('a');
            //   link.href = url;
            //   link.setAttribute('download', filename); //or any other extension
            //   document.body.appendChild(link);
            //   link.click();
            // },
            // saveExcel(){
            //     this.savingExcel=true
            //     // this.errorSearchListing=false
            //     console.log(this.printExcel)
            //     axios.get(this.$baseUrl+'/api/report/excel/unit-sales', this.printPDF,
            //     {
            //         'responseType':'blob',
            //         'headers':
            //         {
            //             'Authorization':'Bearer '+localStorage.getItem('accessToken'),
            //         }
            //     }).then((result)=>{
            //         console.log(result)
            //         this.downloadExcel(result.data,'unit-sales-report.xlsx')
            //         //this.unitreports = result.data.data;
            //         //this.getUnitReports();
            //         this.savingExcel=false
            //         // this.savedListing=true
            //         setTimeout(() => {
            //             // this.savedListing=false
            //             // this.formApplicationActive=false
            //         }, 1000);

            //     }).catch((err)=>{
            //         //check if token fail
            //         if(err.response && err.response.status==401){
            //           localStorage.removeItem('accessToken')
            //         this.$router.push('/login')
            //         }
            //         console.log(err.response)
            //         this.errorExcel=[]
            //         this.errorExcel=Object.values(err.response.data.errors)
            //         console.log(this.errorExcel)
            //         // this.errorSearchListing=true
            //         this.savingExcel=false
            //     })
            // },
            newUsernameChange(){
                this.searchListing.password = this.searchListing.username.toUpperCase();
            },
            deleteItem(item){
                console.log('button delete untuk user id: '+item.id)
            },
            updateUserRoleValue(newValue){
                this.searchListing.role=newValue
            },
            setNewClientId(newId){
                this.searchListing.clientId = newId;
                console.log(this.searchListing.clientId)
            },

            updateApplicationData(){
              console.log('updating data')
              this.updateApplicationState=true
              this.errorApplicationSaved=false
              axios.put(this.$baseUrl+'/api/master/unitreports/'+this.unitreports[this.selectedApplication].id,this.unitreports[this.selectedApplication],
              {
                  'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                if(result.status==200){
                  this.updateApplicationState=false
                  this.updateApplicationSaved=true
                  //step 4 edit
                  this.dataEdit = this.unitreports[this.selectedApplication]
                  setTimeout(() => {
                      this.updateApplicationSaved=false;
                      this.$bvModal.hide('modal-edit-application')
                  }, 1000);
                  console.log('yaya berhasil')
                }
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                  localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                this.updateApplicationState=false
                this.errorApplicationSaved=true
                console.log(err.response)
              })
            },
            editModalClose(mdl){
                //step 2 edit
                this.$set(this.unitreports,this.selectedApplication,this.dataEdit)
                //step 3 edit
                this.dataEdit = Object.assign({},null)
              if(this.updateApplicationState){
                console.log('updating')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-edit-application');
              }
            },
            deleteModalClose(mdl){
              if(this.deleteUserState){
                console.log('deleting')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-delete-user');
              }
            },

            deleteClientData(){
              console.log('deleting data')
              this.deleteUserState=true;
              axios.delete(this.$baseUrl+'/api/master/bank/'+this.users[this.selectedToDelete].id,{
                  'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                if(result.status==200){
                    this.deleteUserState=false;
                    this.userDeleted=true;
                    this.users.splice(this.selectedToDelete, 1);
                    
                  setTimeout(() => {
                      this.$bvModal.hide('modal-delete-user');
                      this.userDeleted=false;
                  }, 1500);
                  console.log('yaya berhasil')
                }
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                  localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                this.deleteUserState=false;
                this.failDeleteUser=true;
                setTimeout(() => {
                      this.failDeleteUser=false;
                  }, 1500);
                console.log(err)
              })
            },
        },
    }
</script>
<style scoped>
::v-deep .modal-content {
    margin: -3.25rem auto;
}

.btn {
    padding : 2px 6px;
}

@media (min-width: 360px) and (max-width: 379.98px) { 
  .custom-select {
    width: 100%;
  }
 }
@media (min-width: 380px) and (max-width: 399.98px) { 
  .custom-select {
    width: 90%;
  }
 }
@media (min-width: 400px) and (max-width: 419.98px) { 
  .custom-select {
    width: 80%;
  }
 }
@media (min-width: 420px) and (max-width: 459.98px) { 
  .custom-select {
    width: 70%;
  }
 }
@media (min-width: 460px) and (max-width: 499.98px) { 
  .custom-select {
    width: 60%;
  }
 }
@media (min-width: 500px) and (max-width: 599.98px) { 
  .custom-select {
    width: 50%;
  }
 }
@media (min-width: 600px) and (max-width: 699.98px) { 
  .custom-select {
    width: 40%;
  }
 }
@media (min-width: 700px) and (max-width: 767.98px) { 
  .custom-select {
    width: 35%;
  }
 }
@media (min-width: 768px) and (max-width: 799.98px) { 
  .custom-select {
    width: 200%;
  }
 }
@media (min-width: 800px) and (max-width: 849.98px) { 
  .custom-select {
    width: 200%;
  }
 }
@media (min-width: 850px) and (max-width: 899.98px) { 
  .custom-select {
    width: 180%;
  }
 }
@media (min-width: 900px) and (max-width: 949.98px) { 
  .custom-select {
    width: 160%;
  }
 }
@media (min-width: 950px) and (max-width: 991.98px) { 
  .custom-select {
    width: 140%;
  }
 }
@media (min-width: 992px) and (max-width: 1049.98px) { 
  .custom-select {
    width: 200%;
  }
 }
@media (min-width: 1050px) and (max-width: 1099.98px) { 
  .custom-select {
    width: 180%;
  }
 }
@media (min-width: 1100px) and (max-width: 1149.98px) { 
  .custom-select {
    width: 160%;
  }
 }
@media (min-width: 1150px) and (max-width: 1199.98px) { 
  .custom-select {
    width: 140%;
  }
 }
@media (min-width: 1200px) { 
  .custom-select {
    width: 130%;
  }
 }
</style>
